import { useWatch } from 'rc-field-form';
import { setPropertiesToRC } from '../utils/setPropertiesToRC.js';
import Form from './Form/index.js';
import useForm from './hooks/useForm.js';
import useSubscribeFieldEvent from './hooks/useSubscribeFieldEvent.js';
import TiFormItem from './FormItem/index.js';
import TiFormGroup from './FormGroup/index.js';
import Input from './fields/Input/index.js';
import TextArea from './fields/TextArea/index.js';
import Picker from './fields/Picker/index.js';
import Selector from './fields/Selector/index.js';
import DatePicker from './fields/DatePicker/index.js';
import DateRangePicker from './fields/DateRangePicker/index.js';
import Switch from './fields/Switch/index.js';
import TiFormRadioGroup from './fields/RadioGroup/index.js';
import TiFormCheckBox from './fields/CheckBoxGroup/index.js';
import Trapezoid from './fields/Trapezoid/index.js';

var TiForm = setPropertiesToRC(Form, {
  useWatch: useWatch,
  useForm: useForm,
  useSubscribeFieldEvent: useSubscribeFieldEvent,
  Item: TiFormItem,
  Group: TiFormGroup,
  Input: Input,
  TextArea: TextArea,
  Picker: Picker,
  Selector: Selector,
  DatePicker: DatePicker,
  DateRangePicker: DateRangePicker,
  Switch: Switch,
  RadioGroup: TiFormRadioGroup,
  CheckBoxGroup: TiFormCheckBox,
  Trapezoid: Trapezoid
});

export { TiForm };
